import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Github, MessageCircle } from 'lucide-react';
import { animeQuotes } from '../../data/philosophy';

const Footer: React.FC = () => {
  const [currentQuote, setCurrentQuote] = useState(0);

  // Rotate quotes every 10 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentQuote(prev => (prev + 1) % animeQuotes.length);
    }, 10000);
    return () => clearInterval(timer);
  }, []);

  const quote = animeQuotes[currentQuote];

  return (
    <footer className="mt-auto border-t" style={{ borderColor: 'var(--color-border)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Rotating anime quote */}
        <div className="text-center mb-6">
          <p className="font-theme italic" style={{ color: 'var(--color-text-secondary)' }}>
            "{quote.quote}"
          </p>
          <p className="text-sm mt-1" style={{ color: 'var(--color-text-secondary)' }}>
            — {quote.character}, <span className="text-gradient">{quote.anime}</span>
          </p>
        </div>

        {/* Links and info */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
              © {new Date().getFullYear()} theweebcoders
            </p>
            <p className="text-xs mt-1" style={{ color: 'var(--color-text-secondary)' }}>
              Everything here is{' '}
              <Link
                to="/license"
                className="text-gradient hover:underline"
              >
                public domain
              </Link>
              {' '}baby.
            </p>
          </div>
          <div className="flex items-center space-x-4">
            <a
              href="https://github.com/theweebcoders"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-lg hover:scale-110 transition-transform"
              style={{ backgroundColor: 'var(--color-primary)' + '20' }}
              aria-label="Visit our GitHub"
            >
              <Github size={20} style={{ color: 'var(--color-primary)' }} />
            </a>
            <a
              href="https://discord.gg/S7NcUdhKRD"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 rounded-lg hover:scale-110 transition-transform"
              style={{ backgroundColor: 'var(--color-primary)' + '20' }}
              aria-label="Join our Discord"
            >
              <MessageCircle size={20} style={{ color: 'var(--color-primary)' }} />
            </a>
          </div>
        </div>

        {/* Easter egg hint */}
        <div className="text-center mt-6">
          <p className="text-xs" style={{ color: 'var(--color-text-secondary)' + '80' }}>
            <span className="opacity-50">
              Pro tip: Try pressing the same number key five times...
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
